// composables/useLogo.ts
/**
 * A simple composable that uses our userData from the authentication cookie to determine what logos are shown vs hidden
 */
export const useLogo = () => {
  const { userData } = useAuth();

  /**
   * Uses the user's dealers to determine if we should show the Arena logo
   */
  const showArenaLogo = computed(() => userData.value?.dealers.some(dealer => !dealer.denyArenaLogo));

  /**
   * Uses the user's dealers to determine if we should show the Eclipse logo
   */
  const showEclipseLogo = computed(() => userData.value?.dealers.some(dealer => !dealer.denyEclipseLogo));

  return {
    showArenaLogo,
    showEclipseLogo
  };
};
